import { useCallback, useEffect, useMemo } from 'react'
import { useSignInForm } from '@open-tender/utils'
import {
  loginCustomer,
  resetLoginError,
  resetOneTimePasscode,
  selectBrand,
  selectCustomer,
  selectGuest,
  selectOneTimePasscode,
  signInCustomer,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { ButtonSubmit, FormError, FormInputs, FormSubmit } from 'components'
import { FormFieldType } from '@open-tender/types'

const SignInForm = () => {
  const dispatch = useAppDispatch()
  const { tpls } = useAppSelector(selectBrand) || {}
  const hasPunch = tpls === 'PUNCHH'
  const { email } = useAppSelector(selectGuest)
  const customer = useAppSelector(selectCustomer)
  const signIn = useAppSelector(selectOneTimePasscode)
  const loading = useMemo(
    () => (hasPunch ? signIn.loading : customer.loading),
    [hasPunch, customer.loading, signIn.loading]
  )
  const error = useMemo(
    () => (hasPunch ? signIn.error : customer.error),
    [hasPunch, customer.error, signIn.error]
  )

  const loginDefault = useCallback(
    (email: string, password?: string) =>
      dispatch(loginCustomer({ email, password: password! })),
    [dispatch]
  )
  const loginTpls = useCallback(
    (email: string, password?: string) =>
      dispatch(signInCustomer({ data: { email, password } })),
    [dispatch]
  )
  const login = hasPunch ? loginTpls : loginDefault

  const {
    submitRef,
    fields,
    data,
    errors,
    submitting,
    handleChange,
    handleSubmit,
  } = useSignInForm(email || '', loading, error, login)

  const onChange = (field: FormFieldType, value: string | number | boolean) => {
    handleChange(field.name, value)
  }

  useEffect(() => {
    if (error) window.scrollTo(0, 0)
  }, [error])

  useEffect(() => {
    dispatch(resetLoginError())
    dispatch(resetOneTimePasscode())
    return () => {
      dispatch(resetLoginError())
      dispatch(resetOneTimePasscode())
    }
  }, [dispatch])

  return (
    <form id="checkout-signin-form" onSubmit={handleSubmit} noValidate>
      <FormError errMsg={errors.form} style={{ margin: '0 0 2rem' }} />
      <FormInputs
        fields={fields}
        data={data}
        onChange={onChange}
        errors={errors}
      />
      <FormSubmit>
        <ButtonSubmit submitRef={submitRef} submitting={submitting}>
          {submitting ? 'Submitting...' : 'Sign In'}
        </ButtonSubmit>
      </FormSubmit>
    </form>
  )
}

export default SignInForm
